module.exports = __webpack_public_path__ + "Aspira-Demi-47c7531d41.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Aspira-Demi.ttf
// module id = 9
// module chunks = 8